import http from "src/common/http";
import {ALL_RIDER_NAME, DEVELOPMENT_URL,GET_ALL_COMPLETED_RIDE,GET_ALL_RIDERS, GET_DOCUMENT_DETAIL, GET_RIDER_DETAIL, UPDATE_DOCUMENT_DETAIL} from "../constants/apiUrl";

const allRiders = (page) => {
    const user = window.sessionStorage.getItem('token');
    
    return http
      .get(DEVELOPMENT_URL + GET_ALL_RIDERS+page, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
       
        return response;
      })
  };

  const getRiderDetail = (riderId) => {
    const user = window.sessionStorage.getItem('token');
    
    return http
      .get(DEVELOPMENT_URL + GET_RIDER_DETAIL+riderId, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
    
        return response;
      })
  };

  const getRiderDocument = (documentId) => {
    const user = window.sessionStorage.getItem('token');
    
    return http
      .get(DEVELOPMENT_URL + GET_DOCUMENT_DETAIL+documentId, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
    
        return response;
      })
  };

  const updateRiderDocument = (documentId,isValidDocumnt) => {
    const user = window.sessionStorage.getItem('token');
    const documentDetail={
      "is_valid_document": isValidDocumnt
    }
    return http
      .put(DEVELOPMENT_URL + UPDATE_DOCUMENT_DETAIL+documentId,documentDetail, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
    
        return response;
      })
  };

  const getAllCompletedRidesWithFilter = (query) => {
    const user = window.sessionStorage.getItem('token');
  
    return http
      .get(DEVELOPMENT_URL + GET_ALL_COMPLETED_RIDE+"?"+query, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
    
        return response;
      })
  };
  const getAllCompletedRides = () => {
    const user = window.sessionStorage.getItem('token');
  
    return http
      .get(DEVELOPMENT_URL + GET_ALL_COMPLETED_RIDE, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
    
        return response;
      })
  };
  
  const getAllRiderName = () => {
    const user = window.sessionStorage.getItem('token');
  
    return http
      .get(DEVELOPMENT_URL + ALL_RIDER_NAME, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
    
        return response;
      })
  };
  
  export default {allRiders, getRiderDetail, getRiderDocument, updateRiderDocument, getAllCompletedRides,getAllCompletedRidesWithFilter,getAllRiderName};